<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('customer.contactAddress') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <div class="form-group">
          <label>
            {{ $t('settings.country.country') }}:
          </label><br>

          <strong>{{ getCountryById(country_id) }}</strong>
        </div>

        <div class="form-group">
          <label>
            {{ $t('ui.nameAndSurename') }}:
          </label><br>

          <strong>{{ name }}</strong>
        </div>

        <div class="form-group">
          <label>
            {{ $t('ui.emailAddress') }}:
          </label><br>

          <strong>{{ email }}</strong>
        </div>

        <div class="form-group">
          <label>
            {{ $t('customer.companyName') }}:
          </label><br>

          <strong>{{ company_name }}</strong>
        </div>

        <div class="form-group">
          <label for="name">
            {{ $t('customer.street') }}:
          </label><br>

          <strong>{{ street }}</strong>
        </div>

        <div class="d-flex">
          <div class="form-group w-100">
            <label>
              {{ $t('customer.building') }}:
            </label><br>

            <strong>{{ building }}</strong>
          </div>

          <div class="form-group w-100 ml-2">
            <label>
              {{ $t('customer.houseNumber') }}:
            </label><br>

            <strong>{{ locale }}</strong>
          </div>
        </div>

        <div class="form-group">
          <label>
            {{ $t('customer.addressLine2') }}:
          </label><br>

          <strong>{{ line_2 }}</strong>
        </div>

        <div class="form-group">
          <label>
            {{ $t('customer.addressLine3') }}:
          </label><br>

          <strong>{{ line_3 }}</strong>
        </div>

        <div class="d-flex">
          <div class="form-group w-100">
            <label>
              {{ $t('customer.zipCode') }}:
            </label><br>

            <strong>{{ postcode }}</strong>
          </div>

          <div class="form-group w-100 ml-2">
            <label>
              {{ $t('customer.city') }}:
            </label><br>

            <strong>{{ city }}</strong>
          </div>
        </div>

        <div class="form-group">
          <label>
            {{ $t('customer.telephone') }}:
          </label><br>

          <strong>{{ phone }}</strong>
        </div>
      </d-form>
    </d-modal-body>
    <d-modal-footer v-if="showEditButton">
      <d-button
        theme="primary"
        outline
        class="ml-auto mr-auto text-nowrap"
        @click.prevent="openEditPopup()">
        {{ $t('ui.edit') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
export default {
  name: 'customer-address-view-popup',
  props: {
    customerID: {
      default: 0,
      type: Number
    },
    addressData: {
      default: () => ({}),
      type: Object
    },
    countries: {
      default: () => ([]),
      type: Array
    },
    showEditButton: {
      default: () => false,
      type: Boolean
    }
  },
  data () {
    return {
      name: '',
      company_name: '',
      country_id: 0,
      street: '',
      email: '',
      building: '',
      locale: '',
      line_2: '',
      line_3: '',
      postcode: '',
      city: '',
      phone: ''
    };
  },
  mounted () {
    this.id = this.addressData.id;
    this.name = this.addressData.name;
    this.email = this.addressData.email;
    this.company_name = this.addressData.company_name;
    this.country_id = this.addressData.country_id;
    this.street = this.addressData.street;
    this.building = this.addressData.building;
    this.locale = this.addressData.locale;
    this.line_2 = this.addressData.line_2;
    this.line_3 = this.addressData.line_3;
    this.postcode = this.addressData.postcode;
    this.city = this.addressData.city;
    this.phone = this.addressData.phone;
  },
  methods: {
    handleClose () {
      this.$bus.$emit('customer-view-address-popup-close');
    },
    cancel () {
      this.handleClose();
    },
    getCountryById (id) {
      let foundedCountry = this.countries.filter(country => country.id === id);

      if (foundedCountry.length) {
        return foundedCountry[0].name;
      }

      return '---';
    },
    openEditPopup () {
      this.handleClose();
      this.$bus.$emit('order-show-address-edit-popup');
    }
  }
}
</script>
